import { useParams } from 'react-router-dom'
import { useBenefitRule } from '@/modules/benefits/hooks/useBenefitRule'
import { useBenefitRuleMutation } from '@/modules/benefits/hooks/useBenefitRuleMutation'
import { BenefitRuleDetail } from '@/modules/benefits/components/BenefitRuleDetail'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function BenefitRuleDetailPage() {
  const { id } = useParams<{ id: string }>()
  const ruleId = Number(id)
  const { data: rule, isLoading, error } = useBenefitRule(ruleId)
  const { remove, isSubmitting: isDeleting } = useBenefitRuleMutation()

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (error) {
    return <ErrorState message={error} />
  }

  if (!rule) return null

  return (
    <BenefitRuleDetail
      rule={rule}
      onDelete={() => remove(ruleId)}
      isDeleting={isDeleting}
    />
  )
}
